import {
    GET_SHOPPING_LIST_DETAILS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_SHOPPING_LIST_DETAILS:
            return {
                ...state,
                SUBMIT_loading: false,
                listDetails: action.listDetails,
            }
        default:
            return state
    }
}